import React, { useEffect } from "react";
import styles from "./CurrencyDropdown.module.css";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { FormHelperText } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setActiveCurrency } from "../../redux/currencySlice";
import { useShoppingCart } from "../../contexts/CartContext";
import { apiRequest } from "../../utils/axiosInstance";

import { UsdFlag } from "./icons/UsdFlag";
import { GbpFlag } from "./icons/GbpFlag";
import { EurFlag } from "./icons/EurFlag";

function CurrencyDropdown(props) {
  const { courses } = props
  const dispatch = useDispatch()
  const { cartItems, setCartItems, cartItemsCoupons, setCartItemsCoupons } = useShoppingCart();
  const activeCurrency = useSelector(
    (state) => state.currency.activeCurrency
  );

  useEffect(() => {
    if (!cartItems.length) return;

    const getCoursesCurrencyPrice = async () => {
      try {
        const courseIds = cartItems.map(item => item.courseId);

        const data = await apiRequest(
          "/getCoursesCurrencyPrice",
          "POST",
          {
            courseIds,
            targetCurrency: activeCurrency
          }
        );
        if (!data?.error) {
          console.log(data.data, 'hoimoieur')
          // const updatedCart = cartItems.map(item => ({
          //   ...item,
          //   display_price: data.prices[item.courseId] ?? item.base_usd_price,
          //   display_currency: activeCurrency
          // }));

          const updatedCart = cartItems.map(item => ({
            ...item,
            price: data.data.prices[item.courseId] ?? item.base_usd_price,
            currency: activeCurrency
          }));

          setCartItems(updatedCart);

          localStorage.setItem(
            "cartPaymentInfo",
            JSON.stringify(updatedCart)
          );

        }

      } catch (error) {
        console.error("Currency update failed", error);
      }
    };

    getCoursesCurrencyPrice();

  }, [activeCurrency]);


  const [age, setAge] = React.useState('');

  const handleChanges = (event) => {
    setAge(event.target.value);
  };

  const options = [
    {
      value: "USD",
      label: "USD",
      flag: <UsdFlag />,
    },

    {
      value: "GBP",
      label: "GBP",
      flag: <GbpFlag />
    },

    {
      value: "EUR",
      label: "EUR",
      flag: <EurFlag />
    },
    // {
    //   value: "AUD",
    // },
    // {
    //   value: "CAD",
    //   flag: <CadFlag />,
    // },
    // {
    //   value: "BDT",
    // },
    // {
    //   value: "PKR",
    // },
    // {
    //   value: "ETC",
    // },

  ]

  //   < CurrencyDropdown
  // label = "Month"
  // options = { options }
  // handleChange = { handleChanges }
  //   />

  const { label, validation } = props;

  const handleChange = (e) => {
    dispatch(setActiveCurrency(e.target.value))

  }
  return (
    <div className={styles.TextField}>
      <div className={styles.FieldLabelContainer}>
        <div className={styles.FieldLabel}>
          <span>{label}</span>
          {validation && <span style={{ color: "#d32f2f" }}>*</span>}
        </div>
        <span className={styles.FieldLabelErrorText}>
          {props.error &&
            props.FieldErrorLabel &&
            (props.FieldLabelHelperText
              ? props.FieldLabelHelperText
              : "Required")}
        </span>
      </div>
      <Select
        className={styles.selectField}
        labelId="customized-select-label"
        id="customized-select"
        value={activeCurrency}
        onChange={handleChange}
        error={props.error}
        defaultValue="USD"
        disabled={props.disabled}
      >
        {options?.map((item, i) => (
          <MenuItem
            selected={activeCurrency}
            key={i}
            value={item.value}
            className={styles.SelectOptionItem}
          >
            {item.flag} {item.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText sx={{ color: "#d32f2f" }}>
        {props.helperText}
      </FormHelperText>
    </div>
  );
}

export default CurrencyDropdown;
